import { createAction, props } from '@ngrx/store';

export const submitUserProfile = createAction(
  '[User Profile] Submit',
  props<{ profileData: any }>()
);

export const submitUserProfileSuccess = createAction(
  '[User Profile] Submit Success',
  props<{ response: any }>()
);

export const submitUserProfileFailure = createAction(
  '[User Profile] Submit Failure',
  props<{ error: any }>()
);

export const fetchUserProfile = createAction(
  '[User Profile] Fetch'
);

export const fetchUserProfileSuccess = createAction(
  '[User Profile] Fetch Success',
  props<{ data: any }>()
);

export const fetchUserProfileFailure = createAction(
  '[User Profile] Fetch Failure',
  props<{ error: any }>()
);

export const updateUserProfile = createAction(
  '[User Profile] Update',
  props<{ id: number, profileData: any }>()
);

export const updateUserProfileSuccess = createAction(
  '[User Profile] Update Success',
  props<{ profile: any }>()
);

export const updateUserProfileFailure = createAction(
  '[User Profile] Update Failure',
  props<{ error: any }>()
);

export const skipSetup = createAction(
  '[User Profile] Skip Setup'
);

export const skipSetupSuccess = createAction(
  '[User Profile] Skip Setup Success',
  props<{ message: string }>()  // Assuming a success message might be returned or utilized
);

export const skipSetupFailure = createAction(
  '[User Profile] Skip Setup Failure',
  props<{ error: any }>()  // Define a more specific type if possible
);
